module.exports = __webpack_public_path__ + "img/hebei.10a1bd4c.jpg";